import { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { message, Modal } from "antd";
import {
  handleActive,
  selectProducts,
  selectCategories,
  disableMenuItemAdminThunk,
  importItemsThunk,
  handleCurrentBranch,
  selectCurrentBranch,
  getAllAdminProducts,
  selectChannels,
} from "../../redux/slices/products";
import { selectUser } from "../../redux/slices/user";
import ProductsUI from "./components/ProductsUI";
import { getAllBranches, selectBranches } from "../../redux/slices/branches";
import { getProductCustomizableChannels, updateProductCustomizableChannels } from "../../api/Products";

const ProductsBySucursal = () => {
  const [loading, handleLoading] = useState(true);
  const products = useSelector(selectProducts);
  const branches = useSelector(selectBranches)
  const categories = useSelector(selectCategories);
  const currentBranch = useSelector(selectCurrentBranch);
  const channels = useSelector(selectChannels);
  const dispatch = useDispatch();

  const user = useSelector(selectUser);
  const [visibleEditor, handleVisibleEditor] = useState(false);

  // States for customizable channels config
  const [customizableChannels, setCustomizableChannels] = useState([]);
  const [loadingCustomizable, setLoadingCustomizable] = useState(false);
  const [savingCustomizable, setSavingCustomizable] = useState(false);

  const fetchCustomizableChannelsList = useCallback(async (branchId) => {
    setLoadingCustomizable(true);
    const targetBranch = branchId || ((!user?.admin && user?.branch) ? user.branch : (currentBranch || user?.branch || 419));
    const response = await getProductCustomizableChannels(targetBranch);
    if (response && response.data && response.data.status === "success") {
      setCustomizableChannels(response.data.channels || []);
    } else {
      message.error("Error al cargar la configuración de canales");
    }
    setLoadingCustomizable(false);
  }, [currentBranch, user?.admin, user?.branch]);

  const initialFetch = useCallback(async () => {
    handleLoading(true);
    const branches = await dispatch(getAllBranches(null, true));

    if (branches.status !== "success") {
      message.error("¡Hubo un problema!");
    }
  }, [dispatch]);

  useEffect(() => {
    initialFetch();
  }, [initialFetch]);

  useEffect(() => {
    const targetBranch = (!user?.admin && user?.branch) ? user.branch : (currentBranch || user?.branch || 419);
    if (targetBranch) {
      (async () => {
        handleLoading(true);
        await dispatch(getAllAdminProducts(targetBranch));
        await fetchCustomizableChannelsList(targetBranch);
        handleLoading(false);
      })();
    }
  }, [currentBranch, user?.admin, user?.branch, fetchCustomizableChannelsList, dispatch]);

  const handleProductActive = async (idProduct, val, type, branch, userId, entityType) => {
    const response = await dispatch(
      handleActive(idProduct, val, type, branch, userId, entityType)
    );
    if (response.status !== "success") {
      message.error("¡Hubo un problema!");
    }
  };

  const confirmVisibility = (sku, mode, active) => {
    Modal.confirm({
      title: `¿${active ? 'Desactivar' : 'Activar'} para todas las sucursales?`,
      okText: "Si",
      cancelText: "No",
      async onOk() {
        const response = await dispatch(disableMenuItemAdminThunk(user.id, sku, mode))
        if (response.status !== "success") {
          message.error("¡Hubo un problema!");
        }
        const targetBranch = (!user?.admin && user?.branch) ? user.branch : (currentBranch || user?.branch || 419);
        dispatch(getAllAdminProducts(targetBranch));
      },
      onCancel() {

      },
    });
  }
  const closeEditor = () => {
    handleVisibleEditor(false)
  }
  const openEditor = () => {
    handleVisibleEditor(true)
  }

  const importItems = async () => {
    const response = await dispatch(importItemsThunk())
    console.log(response)
    if (response.status !== "success") {
      message.error("¡Hubo un problema!");
    }
  }

  const handleSaveCustomizableChannels = async (channelIds) => {
    setSavingCustomizable(true);
    const targetBranch = (!user?.admin && user?.branch) ? user.branch : (currentBranch || user?.branch || 419);
    const response = await updateProductCustomizableChannels(targetBranch, channelIds);
    let success = false;
    if (response && response.data && response.data.status === "success") {
      message.success("Configuración de canales guardada con éxito");
      await dispatch(getAllAdminProducts(targetBranch));
      await fetchCustomizableChannelsList(targetBranch);
      success = true;
    } else {
      message.error("Error al guardar la configuración de canales");
    }
    setSavingCustomizable(false);
    return success;
  };

  const handleBranchChange = async (branch) => {
    handleLoading(true);
    await dispatch(handleCurrentBranch(branch))
    handleLoading(false);
  }
  return (
    <ProductsUI
      loading={loading}
      products={products}
      branches={branches}
      channels={channels}
      initialFetch={initialFetch}
      handleProductActive={handleProductActive}
      handleBranchChange={handleBranchChange}
      categories={categories}
      confirmVisibility={confirmVisibility}
      visibleEditor={visibleEditor}
      closeEditor={closeEditor}
      openEditor={openEditor}
      importItems={importItems}
      customizableChannels={customizableChannels}
      loadingCustomizable={loadingCustomizable}
      savingCustomizable={savingCustomizable}
      fetchCustomizableChannels={fetchCustomizableChannelsList}
      onSaveCustomizableChannels={handleSaveCustomizableChannels}
    />
  );
};

export default ProductsBySucursal;
